import { useEffect, useState } from "react";
import { Trash2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { http, API, errMsg } from "@/lib/api";

export const AdminInstagram = ({ adminKey }) => {
  const headers = { "X-Admin-Key": adminKey };
  const [list, setList] = useState([]);
  const [link, setLink] = useState("");
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => http.get("/instagram").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!file) return toast.error("Choisissez une image");
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("photo", file);
      fd.append("link", link);
      await http.post("/admin/instagram", fd, { headers });
      setLink(""); setFile(null); e.target.reset();
      toast.success("Publication ajoutée");
      load();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  const remove = async (id) => {
    try {
      await http.delete(`/admin/instagram/${id}`, { headers });
      setList((l) => l.filter((p) => p.id !== id));
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  return (
    <div className="grid lg:grid-cols-12 gap-8" data-testid="admin-instagram">
      <form onSubmit={submit} className="lg:col-span-4 bg-white rounded-2xl border border-[#DDD3C6] p-6 space-y-4">
        <h3 className="font-display text-2xl">Ajouter une publication</h3>
        <p className="text-xs text-[#6B5F53]">Image du post ou du réel (capture ou couverture). Le lien est facultatif : sans lien, le clic ouvre votre profil Instagram.</p>
        <input type="file" accept="image/*" onChange={(e) => setFile(e.target.files[0] || null)} className="text-sm" data-testid="insta-photo-input" />
        <Input placeholder="Lien du post (facultatif)" value={link} onChange={(e) => setLink(e.target.value)} className="h-11" data-testid="insta-link-input" />
        <button className="btn-gold w-full justify-center" disabled={busy} data-testid="insta-submit-button">{busy ? <Loader2 size={16} className="animate-spin" /> : "Publier"}</button>
      </form>
      <div className="lg:col-span-8 grid grid-cols-2 sm:grid-cols-3 gap-4">
        {list.length === 0 && <p className="text-[#9A8C7D]">Aucune publication.</p>}
        {list.map((p) => (
          <div key={p.id} className="relative rounded-2xl overflow-hidden border border-[#DDD3C6]" data-testid={`admin-insta-${p.id}`}>
            <img src={`${API}/instagram/${p.id}/photo`} alt="" className="w-full aspect-square object-cover" />
            <button onClick={() => remove(p.id)} className="absolute top-2 right-2 w-8 h-8 rounded-full bg-white/90 flex items-center justify-center hover:text-red-700" data-testid={`admin-insta-delete-${p.id}`}><Trash2 size={14} /></button>
          </div>
        ))}
      </div>
    </div>
  );
};
